import { render, staticRenderFns } from "./PolicyListing.vue?vue&type=template&id=3570a87e&"
import script from "./PolicyListing.vue?vue&type=script&lang=js&"
export * from "./PolicyListing.vue?vue&type=script&lang=js&"
import style0 from "./PolicyListing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports